import React from 'react';
import styled from 'styled-components';

const DepartmentMain = styled.div`
                            background: #F5F5F5;
                            padding: 0px 40px;
                            margin: 0px 0px 20px 0px;
                            text-align:center;
                            .month-title{
                               display:block; 
                               margin-bottom:10px;
                            }
                            .left-border{
                                border-left:1px solid rgba(0,0,0,.125);
                            }
                            .right-border{
                                border-right:1px solid rgba(0,0,0,.125);
                            }
                            .border-both{
                                border-right:1px solid rgba(0,0,0,.125);
                                border-left:1px solid rgba(0,0,0,.125);
                            }
`
const TableSchedule = styled.table`
                            margin-top:40px;
                            width:100%;
                            text-align:left;
                            td, th{
                                border-left: solid 1px #dfdfdf;
                                border-right: solid 1px #dfdfdf;
                            }
                            th{
                                font-size:14px;
                                font-weight:bold;
                                text-align:center;
                                background: #F5F5F5;
                            }
                            td{
                                padding:0px;
                                font-size: 14px;
                                font-weight:normal
                            }
                            .item-start{
                                height:18px;
                                width:100%;
                                border-radius:0px;
                                border-top-left-radius: 9px;
                                border-bottom-left-radius: 9px;
                                border-right:0px;
                            }
                            .item-center{
                                border-radius:0px;
                                height:18px;
                                width:100%;
                                border-left:0px;
                                border-right:0px;
                            }
                            .item-finish{
                                height:18px;
                                width:100%;
                                border-radius:0px;
                                border-top-right-radius: 9px;
                                border-bottom-right-radius: 9px;
                                border-left:0px;
                            }
                            tr:first-child {
                                th{
                                  padding-bottom:25px;      
                                }
                            }
                            tr:nth-child(even) {
                                background: #FFF;
                                td:first-child{
                                    padding-left:6px;
                                    background: #F5F5F5;
                                }
                            }
                            tr:nth-child(odd) {
                                background: #F5F5F5;
                                td{
                                    padding:3px;
                                }
                            }
                            .no-border-left{
                                border-left:0px;
                            }
                            .no-border-right{
                                border-right:0px;
                            }
                            .no-border{
                                border:0px;
                            }
                            .category-header{
                                text-align:left;
                                font-weight:bold;
                                padding-left:5px;
                            }
`
const Schedule = (props) => {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const categories = props.categories;
    const activities = props.activities;

    const getCurrentStatus = item => {

        let date = new Date();

        if (item.status === "completed") {
            return "completed";
        }

        if (item.status === "hold") {
            return "hold";
        }

        if (new Date(item.start) > date) {
            return "scheduled";
        }

        if (date > new Date(item.finish)) {
            return "delayed";
        }
        let warning = false;
        props.dependencies.map((dept, index) => {
            if (dept.children.findIndex(x => x == item.key) !== -1) {

                if (dept.status == 'hold' || (dept.status == 'scheduled' && new Date() > new Date(dept.finish))) {

                    warning = true;

                }
            }
        });
        if (warning) {
            return 'warning';
        } else {
            return "progress";
        }
    };

    const getSchedule = (activity) => {
        let status = getCurrentStatus(activity);
        let date1 = new Date(activity.start);
        let date2 = new Date(activity.finish);

        let currentYear = new Date().getFullYear();

        let year = date2.getFullYear();

        if (date1 > date2) return null;

        let monthArrays = [[], [], []];

        if (year > currentYear) {
            let firstMonth = activity.start.split('-');
            let secondMonth = activity.finish.split('-');

            let startMonth = parseInt(firstMonth[1]);
            let endMonth = parseInt(secondMonth[1]);

            let middle = endMonth - startMonth;
            let end = 12 - endMonth;



            for (let i = 0; i < startMonth - 1; i++) {
                monthArrays[0].push(i)
            }
            for (let i = 0; i < (12 - startMonth); i++) {
                monthArrays[1].push(i)
            }
            // for (let i = 0; i < end; i++) {
            //     monthArrays[2].push(i)
            // }
        } else {
            let firstMonth = activity.start.split('-');
            let secondMonth = activity.finish.split('-');

            let startMonth = parseInt(firstMonth[1]);
            let endMonth = parseInt(secondMonth[1]);

            let middle = endMonth - startMonth;
            let end = 12 - endMonth;

            for (let i = 0; i < startMonth - 1; i++) {
                monthArrays[0].push(i)
            }
            for (let i = 0; i < middle - 1; i++) {
                monthArrays[1].push(i)
            }
            for (let i = 0; i < end; i++) {
                monthArrays[2].push(i)
            }
        }


        return (
            <React.Fragment>
                {monthArrays[0].map((value) =>
                    <td key={value}></td>
                )}
                <td className="no-border-right"><div className={`item-start ${status}`}></div></td>
                {monthArrays[1].map((value) =>
                    <td className="no-border" key={value}><div className={`item-center ${status}`}></div></td>
                )}
                <td className="no-border-left"><div className={`item-finish ${status}`}></div></td>
                {monthArrays[2].map((value) =>
                    <td key={value}></td>
                )}
            </React.Fragment>
        )
    }


    return (
        <DepartmentMain>
            <div className="row show-desktop">
                <div className="col-2">

                </div>
                <div className="col-8 px-0">
                    <TableSchedule>
                        <tbody>
                            <tr>
                                <th className="no-border-left"></th>
                                {months.map((month, index) => (
                                    <th key={index}>{month}</th>
                                ))}
                            </tr>
                            {categories && categories.length > 0 ? categories.map((category, index) => (
                                activities.filter(activity => activity.category === category.slug).length > 0 ?
                                    <React.Fragment key={index}>
                                        <tr>
                                            <th className="no-border-left category-header">{category.name}</th>
                                            {months.map((month, index) => (
                                                <th key={index}></th>
                                            ))}
                                        </tr>
                                        <tr>
                                            <td className="no-border-left"></td>
                                            {months.map((month, index) => (
                                                <th key={index}></th>
                                            ))}
                                        </tr>
                                        {activities.filter(activity => activity.category === category.slug).map((activity, index) => (
                                            <React.Fragment key={index}>
                                                <tr>
                                                    <td className="no-border-left">{activity.name}</td>
                                                    {getSchedule(activity)}
                                                </tr>
                                                <tr>
                                                    <td className="no-border-left"></td>
                                                    {months.map((month, index) => (
                                                        <td key={index}></td>
                                                    ))}
                                                </tr>
                                            </React.Fragment>
                                        ))
                                        }
                                        <tr>
                                            <td className="no-border-left"></td>
                                            {months.map((month, index) => (
                                                <th key={index}></th>
                                            ))}
                                        </tr>
                                        <tr>
                                            <td className="no-border-left"></td>
                                            {months.map((month, index) => (
                                                <th key={index}></th>
                                            ))}
                                        </tr>

                                    </React.Fragment>
                                    : ''
                            )) : ''}
                            <tr>
                                <td className="no-border-left"></td>
                                {months.map((month, index) => (
                                    <th key={index}></th>
                                ))}
                            </tr>
                        </tbody>
                    </TableSchedule>
                </div>
                <div className="col-2">

                </div>
            </div>
        </DepartmentMain>
    );
}

export default Schedule;